import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '@/services/monitoringService'

/**
 * Automatically tracks page views in Azure Application Insights
 * whenever the React Router location changes.
 *
 * Usage: call once at the top level inside <RouterProvider> context.
 */
export function usePageTracking(): void {
  const location = useLocation()

  useEffect(() => {
    trackPageView(location.pathname)
  }, [location.pathname])
}
